export type TopCutout = "dynamic-island" | "notch" | "punch-hole" | "none";
export type SideButton = "power" | "volume-up" | "volume-down" | "volume-toggle" | "silent";

export interface PhoneModel {
  id: string;
  label: string;
  screenWidth: number;
  screenHeight: number;
  frameRadius: number;
  topCutout: TopCutout;
  hasHomeButton: boolean;
  buttonsLeft: SideButton[];
  buttonsRight: SideButton[];
}

export const PHONE_MODELS: PhoneModel[] = [
  {
    id: "iphone-16-pro",
    label: "iPhone 16 Pro",
    screenWidth: 393,
    screenHeight: 680,
    frameRadius: 50,
    topCutout: "dynamic-island",
    hasHomeButton: false,
    buttonsLeft: ["silent", "volume-up", "volume-down"],
    buttonsRight: ["power"],
  },
  {
    id: "iphone-se-3",
    label: "iPhone SE",
    screenWidth: 375,
    screenHeight: 600,
    frameRadius: 40,
    topCutout: "notch",
    hasHomeButton: true,
    buttonsLeft: ["volume-up", "volume-down"],
    buttonsRight: ["power"],
  },
  {
    id: "galaxy-s25",
    label: "Galaxy S25",
    screenWidth: 360,
    screenHeight: 660,
    frameRadius: 44,
    topCutout: "punch-hole",
    hasHomeButton: false,
    buttonsLeft: ["volume-up", "volume-down"],
    buttonsRight: ["power"],
  },
  {
    id: "pixel-9",
    label: "Pixel 9",
    screenWidth: 412,
    screenHeight: 720,
    frameRadius: 42,
    topCutout: "punch-hole",
    hasHomeButton: false,
    buttonsLeft: [],
    buttonsRight: ["power", "volume-toggle"],
  },
] as const satisfies PhoneModel[];
